export default __webpack_public_path__ + "static/media/chat.96b06f1b.svg";